// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
// import { Integrations } from "@sentry/tracing";
import Vue from "vue";
import App from "../../App.vue";
import "../../registerServiceWorker";
import router from "./router";
import store from "../../store";
import ElementUI from "element-ui";
import "../../assets/styles/element/index.css";
import "../../assets/styles/index.css";
// if (process.env.NODE_ENV !== "development") {
//   Sentry.init({
//     dsn: "http://a83109a32313442db019d2025d240a95@sentry.zjweidu.com:8686/5",
//     logErrors:true,
//     integrations: [
//       new VueIntegration({
//         Vue,
//         tracing: true,
//         tracingOptions: {
//           trackComponents: true,
//         },
//       }),

//       new Integrations.BrowserTracing(),
//     ],

//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
//     release:process.env.NODE_ENV,
//   });
// }
Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
